var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { USER_INTENT } from "../lib/constants";
import { close } from "../features/navigation/navigationSlice";
import { closedModal } from "../lib/Avo";
import { onClose } from "../messages";
import useAppDispatch from "../hooks/useAppDispatch";
import useAppSelector from "../hooks/useAppSelector";
import useEventPublisher from "../hooks/useEventPublisher";
import useRouteConfig from "../hooks/useRouteConfig";
export default function useCloseHandler() {
    var eventPublisher = useEventPublisher();
    var isSavvyWidget = useAppSelector(function (state) { return state.configuration; }).isSavvyWidget;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var _a = useAppSelector(function (state) { return state.applicant; }), accountReferenceId = _a.accountReferenceId, selectedIssuer = _a.currentIssuer.auto, accountLinked = _a.accountLinked;
    var closeStatus = useAppSelector(function (state) { return state.navigation.closeStatus; });
    var routeConfig = useRouteConfig();
    var dispatch = useAppDispatch();
    var accountInfo = useAppSelector(function (state) { return state.auth; }).auto.accountInfo;
    var selectedIssuerId = selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.id;
    var connectionId = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.connectionId;
    // Because of timing oddities in our state between App.js and our provider,
    // we need an escape hatch to provide a new ArID on close that might not be propogated
    // to this function. Also, this handler will be "stale" if the ArID changes, to calling it sync
    // in App.js next to code that fetches a new one will need to use this escape hatch
    var handleClose = React.useCallback(function (variables) {
        if (variables === void 0) { variables = {}; }
        var accountReferenceIdOverride = variables.accountReferenceId, status = variables.status, _a = variables.userIntent, userIntent = _a === void 0 ? USER_INTENT.CLOSE : _a, accountLinkedOverride = variables.accountLinked;
        dispatch(close());
        var didLinkAccount = accountLinkedOverride || accountLinked.auto || accountLinked.home;
        eventPublisher.close();
        // Future us will make good use of this nullable error object.
        var error = null;
        var closeMetadata = __assign({ status: status || closeStatus || (routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.status), selected_issuer: selectedIssuerId
                ? __assign(__assign({}, selectedIssuer), { id: selectedIssuerId, 
                    // we need to output the absolute URL in order for the image to properly render for our clients
                    logo: "https://cdn.trellisconnect.com/sdk/v1.1/js-sdk/assets/images/logos/".concat(selectedIssuerId, ".ico") }) : undefined, userIntent: userIntent }, (didLinkAccount && { connectionId: connectionId }));
        // This fragmentation is not cool. Sorry future us.
        if (isSavvyWidget) {
            closeMetadata.accountReferenceId =
                accountReferenceIdOverride || accountReferenceId;
            closeMetadata.accountLinked = didLinkAccount;
        }
        closedModal(commonAnalyticsProperties);
        onClose(error, closeMetadata);
    }, [
        accountReferenceId,
        commonAnalyticsProperties,
        eventPublisher,
        isSavvyWidget,
        routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.status,
        selectedIssuerId,
        selectedIssuer,
        accountLinked,
        connectionId,
        dispatch,
        closeStatus,
    ]);
    return handleClose;
}
